import { Component, OnInit, OnDestroy } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {EmissionService} from 'services/emission.service';
import {Constants} from 'config/constants';
import {SpinnerService} from 'services/spinner.service';
import {BusinessFleetService} from 'services/calculator-items/business-fleet.service';

@Component({
  selector: 'tpc-fleet-ecar',
  templateUrl: './fleet-ecar.component.html',
  styleUrls: ['./fleet-ecar.component.css']
})
export class FleetEcarComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmitted = false;
    private countDefaultValue = 1;
    public isZipValid = true;
    private _form: FormGroup;

    constructor(private emissionService: EmissionService,
                private footerService: FooterNavbarService,
                private fleetService: BusinessFleetService,
                private router: Router,
                private fb: FormBuilder,
                private spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            this.isZipValid = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
    }

    get form(): FormGroup {
        return this._form;
    }

    private createForm() {
        this._form = this.fb.group({
            count: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(1),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            zip: ['', [Validators.required,
                Validators.minLength(3),
                Validators.maxLength(13),
                Validators.pattern(/^[A-Za-z0-9\-\s]+$/i)]],
            mile: ['', [Validators.required]]
        });
    }

    checkError(param) {
        return this.form.get(param).status === 'INVALID' && (this.isFormSubmitted || this.form.get(param).touched);
    }

    next() {
        let calculatorName = Constants.calculators.business;
        let categoryName = 'fleet';
        let params = {
            count: this.getFV('count'),
            ZIP: this.getFV('zip'),
            mile: this.getFV('mile'),
            vehicleType: this.router.url.split('/')[3]
        };

        this.spinner.show();
        this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
            response => {
                let input = response.body[0].input[0];
                if (input.error) {
                    this.isZipValid = false;
                    this.spinner.hide();
                    return;
                }
                this.fleetService.addToVehicleList({
                    title: this.getTitleForVehicleList(params),
                    emission: input.emmission,
                    emissionTrees: input.emissionTrees,
                    DollarAmt: input.DollarAmt,
                    DollarAmtMonthly: input.DollarAmtMonthly
                });

                this.spinner.hide();
                this.router.navigate(['/business/fleet/list']);
            }
        );
    }

    private getTitleForVehicleList(params) {
        return `${params.count + ' Electric' + (params.count === '1' ? ' Car' : ' Cars')}, ${params.mile} mi/yr`;
    }

    getFV(param) {
        return this.form.get(param).value;
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/fleet/fleet-ecar/fleet-ecar.component.ts